// extracted by mini-css-extract-plugin
module.exports = {"current":"Toast_current__of4h2"};